module.exports = __webpack_public_path__ + "img/selecionar_contacto.e887c660.gif";